import {Injectable, isDevMode} from '@angular/core';
import {UserStorageService} from '../user-storage-service/user-storage.service';
import {ReactiveSocket} from 'sockets-lib';
import {map} from 'rxjs/internal/operators';
import {MaintenanceService} from 'src/app/services/maintenance-service/maintenance.service';
import {TurnsService} from 'src/app/services/turns-services/turns-service/turns.service';
import {CommunicationDaoService} from 'src/app/dao/communication-dao-service/communication-dao.service';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  nSocket: ReactiveSocket;

  constructor(private maintenanceService: MaintenanceService,
              private userStorageService: UserStorageService,
              private turnsService: TurnsService,
              private communicationDaoService: CommunicationDaoService
  ) { }


  public connectToLimbo() {
    return this.communicationDaoService.getLimboChannel(this.userStorageService.getLang()).pipe(
      // tap(limbo => consolthis.userStorageService.setComapnyInternalId(limbo.url.split('/'))),
      map(limbo => isDevMode() ?
        this.nSocket = this.communicationDaoService.connect(
          limbo.url, limbo.channel, { secure: true, rejectUnauthorized: false, path: limbo.path }
        ) :
        this.nSocket = this.communicationDaoService.connect(
          limbo.url, limbo.channel, { secure: true, rejectUnauthorized: false, path: limbo.path }
        ))
      );
    }

    public updateAnonymous(socket: ReactiveSocket) {
    socket.emit('updateAnonymous', this.userStorageService.getUDID());
    return socket.listen('registered');
  }

  public listenCommunications() {
    console.log('CommunicationService: listenComuications');
    this.communicationDaoService.getChannel(
      this.userStorageService.getContext(), this.userStorageService.getUDID(), this.userStorageService.getLang()
    ).subscribe(
      (res) => {
        this.userStorageService.setCompanyInternalId(res.channel.split('/')[1]),
        isDevMode() ?
        this.nSocket = this.communicationDaoService.connect(
          res.url, res.channel, { secure: true, rejectUnauthorized: false, path: res.path }
        ) :
        this.nSocket = this.communicationDaoService.connect(
          res.url, res.channel, { secure: true, rejectUnauthorized: false, path: res.path }
        );
        this.nSocket.onConnect().subscribe(
          (connected: ReactiveSocket) => {
            connected.emit('update', this.userStorageService.getContext());
            connected.listen('deviceStatus').subscribe(
              (deviceStatus) => {
                if (deviceStatus['messageContent'] === 'true') {
                  this.maintenanceService.unlockScreen();
                } else {
                  this.maintenanceService.lockScreen();
                }
              }
            );

            connected.listen('updateDevice').subscribe(
              () => {
                this.maintenanceService.refreshDeviceInfo();
              }
            );

            connected.listen('voiceVolume').subscribe(
              () => {
              }
            );

            connected.listen('brightness').subscribe(
              (brightness) => {
                this.maintenanceService.setBrightness(parseInt(brightness['messageContent'], 10));
              }
            );

            connected.listen('screenshot').subscribe(
              () => { }
            );

            connected.listen('deskAdvance').subscribe(
              (deskAdvance) => {
                console.log('deskAdvance');
                this.turnsService.advanceTurn(deskAdvance['messageContent']);
              }
            );

            connected.listen('deskAdvanceObject').subscribe(
              (deskAdvanceObject) => {
                console.log('deskAdvanceObject');
                this.turnsService.deskAdvanceObject(deskAdvanceObject['messageContent']);
              }
            );

            connected.listen('deskTurnTaken').subscribe(
              () => {
                console.log('deskTurnTaken');
                this.turnsService.turnTaken();
              }
            );

            connected.listen('updateDesks').subscribe(
              () => {
                console.log('updateDesks');
                this.turnsService.updateDesks();
              }
            );

            connected.listen('unlockScreen').subscribe(
              () => {
                this.maintenanceService.unlockScreen();
              }
            );

            connected.listen('lockScreen').subscribe(
              () => {
                this.maintenanceService.lockScreen();
              }
            );

            connected.listen('layoutUpdate').subscribe(
              () => {
                this.maintenanceService.refreshLayout();
              }
            );

          }
        );
        this.nSocket.onDisconnect().subscribe(
          (socket: ReactiveSocket) => {
            console.log('onDisconnect');
            this.listenCommunications();
        });
        this.nSocket.onReconnect().subscribe(
          (socket: ReactiveSocket) => {
            console.log('onReconnect');
            this.listenCommunications();
        });
        this.nSocket.onReconnecting().subscribe(
          (socket: ReactiveSocket) => {
            console.log('onReconnecting');
            this.listenCommunications();
        });
        this.nSocket.onReconnectAttempt().subscribe(
          (socket: ReactiveSocket) => {
            console.log('onReconnectAttempt');
            this.listenCommunications();
        });
        this.nSocket.onReconnectError().subscribe(
          (socket: ReactiveSocket) => {
            console.log('onReconnectError');
            this.listenCommunications();
        });
        this.nSocket.onReconnectFailed().subscribe(
          (socket: ReactiveSocket) => {
            console.log('onReconnectFailed');
            this.listenCommunications();
        });
      }
    );
  }

}
